import { motion } from "framer-motion";
import { MaskLines } from "./motion";
import { SectionLabel } from "./SectionLabel";
import { ease } from "../lib/content";

const STEPS = [
  ["Needs assessment", "Understanding the crop, the pest complex, current practices and what success looks like for you."],
  ["Strategy development", "Designing an IPM, biological control or biodiversity strategy that fits the system and the market."],
  ["Field experimentation", "Applied R&D and trials that test and refine solutions under real growing conditions."],
  ["Implementation & transfer", "Field roll-out, monitoring and extension so growers and advisors can carry it forward."],
];

export const Process = ({ index = "04" }) => (
  <section data-testid="process-section" className="grain relative bg-teal py-24 text-mist sm:py-32">
    <div className="relative mx-auto grid max-w-[1440px] gap-16 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <SectionLabel index={index} className="text-sage">How we work</SectionLabel>
          <MaskLines
            lines={["From needs", "assessment to", "field implementation."]}
            className="mt-8 font-display text-4xl font-normal leading-[1.02] tracking-[-0.02em] sm:text-5xl lg:text-6xl"
          />
          <p className="mt-8 max-w-md text-[15px] leading-relaxed text-mist/80">
            Agroecological expertise, practical crop protection experience and applied innovation, brought together at every stage of a project.
          </p>
        </div>
      </div>
      <ol className="lg:col-span-6 lg:col-start-7">
        {STEPS.map(([t, d], i) => (
          <motion.li
            key={t}
            data-testid={`process-step-${i}`}
            className="relative border-t border-mist/15 py-10"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, ease }}
          >
            <motion.span
              className="absolute left-0 top-[-1px] h-px w-full origin-left bg-sage"
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 1.4, ease, delay: 0.2 }}
            />
            <div className="grid grid-cols-[4rem_1fr] gap-4 sm:grid-cols-[6rem_1fr]">
              <span className="font-display text-4xl font-light text-sage sm:text-5xl">0{i + 1}</span>
              <div>
                <h3 className="font-display text-2xl font-normal sm:text-3xl">{t}</h3>
                <p className="mt-3 max-w-md text-[15px] leading-relaxed text-mist/80">{d}</p>
              </div>
            </div>
          </motion.li>
        ))}
      </ol>
    </div>
  </section>
);
